import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIGameAchievementEventEmitter } from '@colonist/ui-game';
export class UIGameAchievementController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.PlayerReceivedAchievement:
                this.achieve(data);
                break;
            default:
                break;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    achieve(options) {
        UIGameAchievementEventEmitter.emit('addAchievement', options);
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
